<template>
	<div id="error">
        <div class="clear_a">
            <img :src="errorIcon" >
            <p>暂未开放该功能!</p>
        </div>
	</div>
</template>

<script>
	export default {
		components: {
		
		},
		name: "home",
		data() {
			return {
                errorIcon:require('assets/img/bigDataError.png')
            }
		},
		methods: {
		
		},
		mounted() {
		
		}
	};
</script>

<style scoped lang='scss'>
	#error {
  width: 100%;
  // height: 100%;
  >div{
    width: 800px;
    height: 230px;
    margin: 100px auto 0;
    p{
      font-size:36px;
      font-family:PingFangSC-Semibold;
      color:rgba(57,57,57,1);
      line-height:230px;
    }
  }
}
</style>